import accounting from 'accounting';

export function formatIntlPhoneNumber(phoneString) {
  // Filter only numbers from the input
  const cleaned = String(phoneString).replace(/\D/g, '');

  // Check if the input is of correct length
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    // Remove the matched extension code
    // Change this to format for any country code.
    const intlCode = match[1] ? '+1-' : '';
    return `${intlCode}(${match[2]}) ${match[3]}-${match[4]}`;
  }

  return null;
}

export const formatMoney = (value) => {
  return accounting.formatMoney(value, '$', 0);
};

export const formatMiles = (value) => {
  return accounting.formatNumber(value);
};
